import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Logo } from './Logo';
import { Mail, ExternalLink } from 'lucide-react';

export const Footer = () => {
  const { t } = useTranslation();
  return (
    <footer className="bg-[#111111] border-t border-[#F5820D]/20 pt-8 pb-4 md:pt-12 md:pb-6">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-3 md:grid-cols-3 gap-4 md:gap-10 mb-6 md:mb-10">
          {/* Brand */}
          <div>
            <Logo size="md" className="mb-4" variant="white" />
            <p className="text-white/60 text-xs md:text-sm font-manrope leading-relaxed mt-1 md:mt-2 hidden md:block">
              {t('footer.tagline')}
            </p>
          </div>

          {/* Links */}
          <div>
            <h4 className="font-oswald text-white uppercase tracking-widest text-xs md:text-sm mb-2 md:mb-4">Navigation</h4>
            <ul className="space-y-1 md:space-y-2">
              <li><Link to="/" className="text-white/60 hover:text-[#F5820D] text-xs md:text-sm font-manrope transition-colors">{t('nav.home')}</Link></li>
              <li><Link to="/produits" className="text-white/60 hover:text-[#F5820D] text-xs md:text-sm font-manrope transition-colors">{t('nav.products')}</Link></li>
              <li><Link to="/a-propos" className="text-white/60 hover:text-[#F5820D] text-xs md:text-sm font-manrope transition-colors">{t('nav.about')}</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-oswald text-white uppercase tracking-widest text-xs md:text-sm mb-2 md:mb-4">Contact</h4>
            <a href={`mailto:${t('footer.contact_email')}`} className="flex items-center gap-1 md:gap-2 text-white/60 hover:text-[#F5820D] text-xs md:text-sm font-manrope transition-colors mb-2 md:mb-3">
              <Mail size={12} className="shrink-0" />
              <span className="truncate">{t('footer.contact_email')}</span>
            </a>
            <a
              href="https://ultratiming.live"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-1 md:gap-2 text-[#F5820D] hover:text-[#F5C842] text-xs md:text-sm font-manrope transition-colors"
            >
              <ExternalLink size={12} className="shrink-0" />
              {t('footer.ultratiming')}
            </a>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-white/10 pt-3 md:pt-6 flex flex-col md:flex-row items-center justify-between gap-1 md:gap-3">
          <p className="text-white/40 text-xs font-manrope">{t('footer.copyright')}</p>
          <a
            href="https://ultratiming.live"
            target="_blank"
            rel="noopener noreferrer"
            className="text-white/40 hover:text-white/70 text-xs font-manrope transition-colors flex items-center gap-1"
          >
            Une réalisation UltraTiming <ExternalLink size={11} />
          </a>
        </div>
      </div>
    </footer>
  );
};
